<template>
  <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">

    <vx-card title="Domain ของ Sms">
      <vs-table :data="infoSms">
        <template slot="thead">
          <vs-th>
            ลำดับ
          </vs-th>
          <vs-th>
            โดเมน
          </vs-th>
          <vs-th>
            ชื่อเว็บ
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td :data="data[indextr].domain">
              {{ data[indextr].domain }}
            </vs-td>

            <vs-td :data="data[indextr].website">
              {{ data[indextr].website }}
            </vs-td>


            <vs-td :data="data[indextr].id">
              <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" type="border"
                size="small" icon-pack="feather" icon="icon-edit" class="mr-2"
                @click="edit(indextr)">แก้ไข</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vs-popup classContent="popup-example" :title="infopopup.website" :active.sync="showpopup">
      <div class="vx-row ">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
          <vs-input class="w-full" label-placeholder="Domain" v-model="infopopup.domain" type="text" name="Newturn" />
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
          <vs-input class="w-full" label-placeholder="website" v-model="infopopup.website" type="text" name="Newturn" />
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
        </div>
      </div>
      <br>
      <vs-input class="w-full" label-placeholder="OTP" v-model="infopopup.otp"  name="Newturn" />
      <small class="text-danger" >กรุณากรอก OTP ทุกครั้งเพื่อยืนยันการแก้ไข</small>
      <br>
      <br>
      <vs-button :disabled="$store.state.AppActiveUser.permissions.settingSms.action ? false : true" size="small"
        icon-pack="feather" icon="icon-edit" class="mr-2" @click="confirm_edit()">ยืนยัน</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import axios from '../../axios'

export default {

  data () {
    return {
      infoSms: '',
      showpopup: false,
      infopopup: {
        domain: '',
        website: '',
        otp: ''
      },
      error: ''
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  mounted () {
    this.callinfo()
  },
  methods: {
    callinfo () {
      axios
        .get('/settingsms/info')
        .then(response => (this.infoSms = response.data))
    },
    currency (amount) {
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return (amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        return `${(amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
      }

    },
    edit (index) {
      const i = index
      this.infopopup.domain = this.infoSms[i].domain
      this.infopopup.website = this.infoSms[i].website
      this.showpopup = true
    },
    async confirm_edit () {
      await axios.post('/settingsms/editinfo', {
        domain: this.infopopup.domain,
        website: this.infopopup.website,
        token : this.infopopup.otp
      })
        .then(response => (this.error = response.data))
      if (this.error.status === true) {

        this.$vs.notify({
          time: 10000,
          color: 'success',
          position: 'top-right',
          icon: 'error',
          text: this.error.info,
          title: 'ทำรายการสำเร็จ'
        })
        this.callinfo()
        this.showpopup = false
        this.infopopup.otp = ''
      } else {
        this.callinfo()
        this.showpopup = false
        this.infopopup.otp = ''
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          text: this.error.info,
          title: 'ทำรายการผิดพลาด'
        })

      }
    }
  }
}

</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
